export default __webpack_public_path__ + "static/media/I0006.015ee5e9.png";